export enum ScoringIndicatorClassNames {
  BirdieOuterCircle = 'rounded-full min-w-6 min-h-6 lg:w-7 lg:h-7 p-0 ring',
  BogeyOuterSquare = 'ring p-0 ring-offset-1 min-w-6 min-h-6 lg:w-7 lg:h-7',
  EagleInnerCircle = 'rounded-full ring',
  EagleOuterCircle = 'rounded-full min-w-6 min-h-6 lg:w-7 lg:h-7 p-0 ring ring-offset-1',
  DoubleBogeyOuterSquare = 'ring ring-offset-1 p-0 min-w-6 min-h-6 lg:w-7 lg:h-7',
  DoubleBogeyInnerSquare = 'ring',
}
